import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDropzone } from 'react-dropzone';
import { Box, Typography } from '@mui/material';
import { VpButton } from '@vp-ui';
import { UploadCloud } from 'react-feather';

export const VpDropzone = ({ accept, title, subtitle, logoUrl, onDrop = () => {} }) => {
  const [isHover, setIsHover] = useState(false);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept,
    onDrop: onDrop,
  });

  return (
    <div>
      <Box
        onMouseEnter={() => setIsHover(true)}
        onMouseLeave={() => setIsHover(false)}
        {...getRootProps()}
        sx={{
          p: 2,
          border: '1px dashed #C7C7CC',
          borderColor: isDragActive || isHover ? 'vpColors.blueMain' : 'grey.400',
          bgcolor: isDragActive || isHover ? 'vpColors.blueLighter' : 'transparent',
          borderRadius: '8px',
          color: 'text.secondary',
          textAlign: 'center',
          cursor: 'pointer',
          height: 200,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <input {...getInputProps()} />
        {logoUrl ? (
          <img height="100px" src={logoUrl} alt="Preview" />
        ) : (
          <>
            <UploadCloud color="#8E8E93" strokeWidth={1} size={42} />
            <Typography sx={{ mt: '4px', fontSize: 14 }}>{title}</Typography>
            <Typography sx={{ color: 'grey.500', fontSize: 14 }}>{subtitle}</Typography>
            <VpButton sx={{ mt: '16px' }} variant={isHover ? 'contained' : 'outlined'}>
              Select File
            </VpButton>
          </>
        )}
      </Box>
    </div>
  );
};

VpDropzone.propTypes = {
  accept: PropTypes.arrayOf(PropTypes.string),
  logoUrl: PropTypes.string,
  onDrop: PropTypes.func,
  subtitle: PropTypes.string,
  title: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/vp-ui/inputs/VpDropzone.jsx